import styled from 'styled-components';

const SuccessWrapper = styled.div`
.payment-details-wrapper{
    text-align: initial;
    // font-family: 'OpenSans', Tahoma, Geneva, Verdana, sans-serif;
    padding-bottom: 120px;
    .row-flex {
      display: flex;
      flex-wrap: wrap;
    }
    .content {
      height: 100%;
    }
    .header-wrapper{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text{
        h1{
          font-family: 'Bliss2', Tahoma, Geneva, Verdana, sans-serif;
          font-size: 32px;
          font-weight: bold;
          color: #34a853;
          margin: 100px 0 20px 0;
          text-transform: capitalize;
        }
        p{
          color: #4c565c;
          font-size: 17px;
          margin-bottom: 70px;
        }
      }
    }
  
    .sadad-table{
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      padding: 0;
      border: solid 1px #edf2f5;
      .table-header{
        padding: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3{
          font-family: 'Bliss2', Tahoma, Geneva, Verdana, sans-serif;
          font-size: 20px;
          font-weight: bold;
          text-transform: capitalize;
          color: #4c565c;
        }
      }
      .table-body{
        padding: 16px;
        display: flex;
        flex-direction: column;
        border-top: solid 1px #edf2f5;
        .cell{
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-grow: 1;
          border-bottom: solid 1px #edf2f5;
          padding: 16px 0;
          &:first-of-type{
            padding-top: 0;
          }
          &:last-of-type{
            border: 0;
          }
          p{
            font-size: 16px;
            color: #4c565c;
            margin: 0;
          }
          .text{
  
          }
          .description{
            display: inline-flex;
            align-items: center;
            img{
              margin: 0 5px;
            }
            svg{
              margin-right: 10px;
            }
            &.active{
              path{
                fill: #6B47F5;
              }
            }
          }
  
        }
        .store-link{
          margin-top: 16px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            margin: 0 10px;
          }
        }
      }
    }
  }

`;

export default SuccessWrapper;